import { AUTHENTICATE, JOIN_ROOM, LEAVE_ROOM, SEND_MESSAGE, WS_CONNECT, WS_DISCONNECT, WS_LOGOUT, WS_RECONNECT_SUCCESS } from './constants';

var connect = function connect() {
  var clientType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PRO';
  var applicationType = arguments.length > 1 ? arguments[1] : undefined;
  var params = arguments.length > 2 ? arguments[2] : undefined;
  return {
    type: WS_CONNECT,
    payload: {
      clientType: clientType,
      applicationType: applicationType,
      params: params
    }
  };
};

var authenticate = function authenticate() {
  return {
    type: AUTHENTICATE
  };
};

var logout = function logout() {
  return {
    type: WS_LOGOUT
  };
};

var reconnect = function reconnect() {
  return {
    type: WS_RECONNECT_SUCCESS
  };
};

var disconnect = function disconnect() {
  return {
    type: WS_DISCONNECT
  };
};

var join = function join(room) {
  var resource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: JOIN_ROOM,
    payload: {
      room: room,
      resource: resource,
      options: options
    }
  };
};

var leave = function leave(room) {
  return {
    type: LEAVE_ROOM,
    payload: {
      room: room
    }
  };
};

var message = function message(room, body) {
  return {
    type: SEND_MESSAGE,
    payload: {
      room: room,
      body: body
    }
  };
};

export default {
  connect: connect,
  authenticate: authenticate,
  logout: logout,
  join: join,
  leave: leave,
  message: message,
  reconnect: reconnect,
  disconnect: disconnect
};
//# sourceMappingURL=websocket.js.map